import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PropertyCard from "@/components/PropertyCard";

/**
 * Renders up to 6 similar properties in the same city.
 * Adds crucial internal links for SEO on every property page.
 */
export default function RelatedProperties({ propertyId, cityName }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/properties/${propertyId}/similar`, { params: { limit: 6 } })
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [propertyId]);

  if (loading) {
    return (
      <section className="mt-14" data-testid="related-loading">
        <p className="label-eyebrow text-gray-500 mb-2">You may also like</p>
        <div className="h-40 rounded-2xl bg-gray-100 animate-pulse" />
      </section>
    );
  }

  if (!items.length) return null;

  return (
    <section className="mt-14" data-testid="related-properties">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <p className="label-eyebrow text-gray-500">You may also like</p>
          <h2 className="font-display text-3xl text-[#7A1E2A]">
            Similar homes {cityName ? `in ${cityName}` : ""}
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((p) => (
          <PropertyCard key={p.id} property={p} />
        ))}
      </div>
    </section>
  );
}
